// side effect: fetch new pvgis data when decisions are made
import {fetchPvgisHourly, setSolarActivityLevel, setSolarAzimuth, setSolarDimmProfile, setSolarGenerators} from './solarSlice';
import {decision, decisions, fetchConsequences, fetchDecisions} from '../slices/decisionsSlice';
import {
	selectSolarActivityLevel,
	selectSolarAzimuth,
	selectSolarAzimuthAngle, selectSolarDimmProfile,
	selectSolarHeight,
	selectSolarLuminarCountValue,
	selectSolarLumPosition1,
	selectSolarLumPosition2, selectSolarVersion
} from './solarSelectors';

async function setLuminairePositions(store) {
	const headCount = selectSolarLuminarCountValue(store.getState());
	const height1 = parseInt(selectSolarLumPosition1(store.getState()), 10);
	const height2 = parseInt(selectSolarLumPosition2(store.getState()), 10);
	const baseHeightValue = selectSolarHeight(store.getState());
	const baseHeight = baseHeightValue ? parseInt(baseHeightValue, 10) / 10 : 0;

	const pos1 = (baseHeight + height1) * 10;
	const pos2 = (baseHeight + height2) * 10;
	const supos1 = height1 * 10;
	const supos2 = height2 * 10;

	const features = [];

	features.concat([
		{
			variableId: 'LE_LuminairePositionAngle_1',
			featureValues: [
				{
					featureValueId: '000',
					state: 'Included',
					kind: 'Explicit'
				}
			]
		},
		{
			variableId: 'LE_LuminairePositionHeight_1',
			featureValues: [
				{
					featureValueId: '' + pos1,
					state: 'Included',
					kind: 'Explicit'
				}
			]
		},
		{
			variableId: 'LE_LuminairePositionHeightSU_1',
			featureValues: [
				{
					featureValueId: '' + supos1,
					state: 'Included',
					kind: 'Explicit'
				}
			]
		}
	]);
	if (headCount === 2) features.concat([
		{
			variableId: 'LE_LuminairePositionAngle_2',
			featureValues: [
				{
					featureValueId: '180',
					state: 'Included',
					kind: 'Explicit'
				}
			]
		},
		{
			variableId: 'LE_LuminairePositionHeight_2',
			featureValues: [
				{
					featureValueId: '' + pos2,
					state: 'Included',
					kind: 'Explicit'
				}
			]
		},
		{
			variableId: 'LE_LuminairePositionHeightSU_2',
			featureValues: [
				{
					featureValueId: '' + supos2,
					state: 'Included',
					kind: 'Explicit'
				}
			]
		},
	]);

	await store.dispatch(decisions({
			features: features,
			attributes: []
		}
	));
	store.dispatch(fetchDecisions());
	store.dispatch(fetchConsequences());

}

export const solarMiddleware = store => next => async action => {
	const result = next(action);
	const state = store.getState();
	if (store.getState().status.family === 'Aeto') {

		if (action.type === 'decisions/decision/fulfilled') {
			// set SolarUnit feature when number of heads is decided/changed
			const generators = state.solar.data.project.generators;
			const constructionFeature = action.payload.affectedDecisions.features.find(f => f.variableId === 'HS_Construction');
			if (constructionFeature) {
				const constructionFeatureValue = constructionFeature.featureValues.find(fv => fv.state === 'Included');
				let solarUnit = generators + 'm2L';
				if (constructionFeature && constructionFeatureValue && constructionFeatureValue.featureValueId === '1head') {
					solarUnit = generators + 'm1L';
				}
				//store.dispatch(setSolarGenerators({id: 4}));
				/*
				store.dispatch(decision(
					{
						variableId: 'LU_SolarUnit',
						featureValueId: solarUnit,
						state: 'Included'
					}
				));
				 */
				store.dispatch(decision(
					{
						variableId: 'LU_SolarUnitHeight',
						featureValueId: generators,
						state: 'Included'
					}
				));
			}
		}

		if (action.type === 'decisions/decision/fulfilled') {
			// when setting to Basic, configure to use without motion sensor
			if (selectSolarVersion(state) === 'AetoBasic') {
				if (selectSolarDimmProfile(state) === 'profile0' ||
					selectSolarDimmProfile(state) === 'profile1' ||
					selectSolarDimmProfile(state) === 'profile2') {
					/// setDimmProfile to profile4
					store.dispatch(setSolarDimmProfile({id: 'profile3'}));
				}
				if (selectSolarActivityLevel(state) !== 'none') {
					store.dispatch(setSolarActivityLevel({id: 'none'}));
				}
			}
		}

		// enforce PRO and MotionSensor when needed
		if (action.type === 'solar/setSolarDimmProfile') {
			if (selectSolarDimmProfile(state) === 'profile0' ||
				selectSolarDimmProfile(state) === 'profile1' ||
				selectSolarDimmProfile(state) === 'profile2') {
				store.dispatch(decision(
					{variableId: 'HS_HousingSize', featureValueId: 'AetoPro', state: 'Included'}
				));
				//store.dispatch(decision(
				//	{variableId: 'EB_MotionSensor_1', featureValueId: 'Yes', state: 'Included'}
				//));
			} else {
				store.dispatch(decision(
					{variableId: 'EB_MotionSensor_1', featureValueId: 'None', state: 'Included'}
				));
			}

		}
		if (action.type === 'solar/setSolarActivityLevel') {
			console.log('setSolarActivityLevel activityLevel', selectSolarActivityLevel(state), selectSolarVersion(state));
			if (selectSolarActivityLevel(state) !== 'none') {
				store.dispatch(decision(
					{variableId: 'HS_HousingSize', featureValueId: 'AetoPro', state: 'Included'}
				));
			}
		}

		// set motion sensor based on activity level
		if (action.type === 'solar/setSolarActivityLevel') {
			if (action.payload.id === 'none') {
				store.dispatch(decision(
					{variableId: 'EB_MotionSensor_1', featureValueId: 'None', state: 'Included'}
				));
			} else {
				store.dispatch(decision(
					{variableId: 'EB_MotionSensor_1', featureValueId: 'Yes', state: 'Included'}
				));
			}
		}

		if (action.type === 'solar/fetchSolarLocation/fulfilled') {
			const solar = store.getState().solar.data;
			await store.dispatch(setSolarAzimuth({id: solar.project.location.latitude > 0 ? 'n' : 's'}));
			console.log('latitude', solar.project.location.latitude, solar.project.azimuth);
		}

		if (action.type === 'solar/setSolarAzimuth' || action.type === 'solar/fetchSolarLocation/fulfilled' || action.type === 'solar/setSolarData') {
			const solar = store.getState().solar.data;

			// get pvgis daa when not already available and location is set
			if ((!solar.project.orientation || solar.project.orientation.left.pvgisDaily === null) &&
				solar.project.azimuth !== null && solar.project.location !== null && solar.project.location.latitude !== null && solar.project.location.longitude !== null
			) {
				const angle = selectSolarAzimuthAngle(store.getState());
				//get the new pvgis data
				const options = {
					lat: solar.project.location.latitude,
					lon: solar.project.location.longitude,
					outputformat: 'json',
					usehorizon: '1',
					userhorizon: '0',
					startyear: '2018',
					endyear: '2023',
					pvcalculation: '1',
					pvtechchoice: 'crystSi',
					loss: '14',
					raddatabase: '',
					trackingtype: '0',
					optimalangles: '0',
					optimalinclination: '0',
					components: '1',
					peakpower: solar.project.panelPdc / 1000,
					mountingplace: 'free', // building / free
					aspect: 0, //azimuth selectSolarAzimuthAngle(store.getState()) ??
					angle: 90, //surface_tilt
				};
				// clone options with different aspect property (-180 - 180 degree)
				store.dispatch(fetchPvgisHourly({...options, aspect: ((angle + 0) + 360) % 360 - 180, orientation: 'front'}));
				store.dispatch(fetchPvgisHourly({...options, aspect: ((angle + 90) + 360) % 360 - 180, orientation: 'left'}));
				store.dispatch(fetchPvgisHourly({...options, aspect: ((angle + 180) + 360) % 360 - 180, orientation: 'back'}));
				store.dispatch(fetchPvgisHourly({...options, aspect: ((angle - 90) + 360) % 360 - 180, orientation: 'right'}));
			}
		}
	}
	return result;
};
